export const paymentSectionNew = {
  name: "payment",
  label: "Auszahlungen",
  description: "",
  children: [
    {
      control: "switch",
      name: "vorsteuerabzugsberechtigt",
      label: "Vorsteuerabzugsberechtigt",
      cols: "12",
    },
    {
      control: "select",
      name: "auszahlung_schaden_bank_account_id",
      label: "Auszahlungskonto",
      cols: "12",
      // The resolver already narrows this to at most one candidate account
      // (BankAccountResolver::resolveForObject()) - preselect it so field
      // staff aren't left picking between "the account" and "individuelle
      // Bankverbindung" for no reason. Opt-in and scoped to this field only,
      // see useSelectOptions.js.
      auto_select_single_option: true,
      get_api: {
        endpoint: "data/bank-accounts",
        params: { objekt_id: { from_field: "objekt_id" } },
        map_result: {
          key: "id",
          label: { concat: ["iban", " - ", "bic", " - ", "bank_name"] },
          prepend: [{ key: "", label: "Individuelle Bankverbindung" }],
          if_empty: [{ key: "", label: "Individuelle Bankverbindung" }],
        },
      },
    },
    {
      control: "input",
      name: "auszahlung_schaden_kontoinhaber",
      label: "Kontoinhaber",
      cols: "12",
      hidden: {
        when: { field: "auszahlung_schaden_bank_account_id", truthy: true },
      },
    },
    {
      control: "input",
      name: "auszahlung_schaden_bank",
      label: "Bank (Name)",
      cols: "12",
      hidden: {
        when: { field: "auszahlung_schaden_bank_account_id", truthy: true },
      },
    },
    {
      control: "input",
      name: "auszahlung_schaden_iban",
      label: "IBAN",
      cols: "6",
      valid: [{ fn: "iban" }],
      hidden: {
        when: { field: "auszahlung_schaden_bank_account_id", truthy: true },
      },
    },
    {
      control: "input",
      name: "auszahlung_schaden_bic",
      label: "BIC",
      cols: "6",
      hidden: {
        when: { field: "auszahlung_schaden_bank_account_id", truthy: true },
      },
    },
  ],
};
